import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, switchMap } from 'rxjs';
import { AuthCheckService } from '../../services/auth-check.service';
import { ConfigService } from '../../services/config.service';
import { LoadingOverlayService } from '../../services/loading-overlay.service';
import { DailyForecast, HourlyForecast, NextHourForecast } from '../api.entities';
import { ApiService } from '../api.service';
import { UserPreferencesApi } from '../user-preferences/user-preferences-api.service';

@Injectable({
  providedIn: 'root',
})
export class WeatherApi extends ApiService {
  constructor(
    config: ConfigService,
    loadingOverlayService: LoadingOverlayService,
    matSnackBar: MatSnackBar,
    authCheckService: AuthCheckService,
    private userPreferencesApi: UserPreferencesApi
  ) {
    super(config, loadingOverlayService, matSnackBar, authCheckService);
  }

  getNextHourForecast(): Observable<NextHourForecast> {
    return this.userPreferencesApi.get().pipe(
      switchMap(prefs =>
        this.request(
          this.client.GET('/api/weather/next-hour-forecast', {
            params: { query: { location: prefs.weatherLocation ?? '' } },
          }),
          false
        )
      )
    );
  }

  getHourlyForecast(): Observable<HourlyForecast[]> {
    return this.userPreferencesApi.get().pipe(
      switchMap(prefs =>
        this.request(
          this.client.GET('/api/weather/hourly-forecast', {
            params: { query: { location: prefs.weatherLocation ?? '' } },
          }),
          false
        )
      )
    );
  }

  getDailyForecast(): Observable<DailyForecast[]> {
    return this.userPreferencesApi.get().pipe(
      switchMap(prefs =>
        this.request(
          this.client.GET('/api/weather/daily-forecast', {
            params: { query: { location: prefs.weatherLocation ?? '' } },
          }),
          false
        )
      )
    );
  }
}
